export default __webpack_public_path__ + "33150f61713dab6bfd9e1e32b7d5a7b0.png";